import React from "react";
import { Box, Stack } from "@mui/material";
import { FACILITY_FAQ_DATA } from "../../../constants/richSearch/faqData";

export function FacilityDetailFAQ() {
  return (
    <Stack gap="10px" padding="40px 20px">
      <h2 className="subtitle_16_b">장지 자주 묻는 질문</h2>
      <Stack gap="32px">
        {FACILITY_FAQ_DATA.map((item, i) => (
          <Stack key={i} gap="4px">
            <Box className="subtitle_14_b gray900">{item.q}</Box>
            <Box className="body_14_m gray700">{item.a}</Box>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}
